<template>
  <div v-if="isEntrega">
    <v-row dense>
      <v-col cols="12" sm="6" md="7">
        <p class="mb-1">
          <span class="title font-weight-bold text--primary">
            {{ aprovacao.locaisEntrega.nomeLocal }}
          </span>
        </p>
      </v-col>
    </v-row>
    <p class="mt-2" v-if="aprovacao.locaisEntrega.codigoInterno">
      {{ aprovacao.locaisEntrega.codigoInterno }}
    </p>
    <p>
      <v-icon>mdi-map-marker</v-icon>
      {{ aprovacao.locaisEntrega.endereco | endereco }}
    </p>
  </div>
  <div v-else>
    <v-row dense>
      <v-col cols="12" sm="6" md="7">
        <p class="mb-1">
              <span class="title font-weight-bold text--primary">
                {{ aprovacao.comprador.pessoa.nome }}
              </span>
        </p>
      </v-col>
    </v-row>
    <p class="mt-2">
      <v-icon>mdi-domain</v-icon>
      {{ aprovacao.comprador.pessoa.cnpj | cnpj }}
    </p>
    <p>
      <v-icon>mdi-map-marker</v-icon>
      {{ aprovacao.comprador.endereco | endereco }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    aprovacao: Object,
    isEntrega: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
